import React, { useEffect, useState } from "react";
import { Row, Col, FormGroup, Label, Input, CardBody } from "reactstrap";
import Select from "react-select";
import { customStyle, sellerOptions } from "components/Common/constants";
import { useDispatch, useSelector } from "react-redux";
import { useMemo } from "react";
import { getManufacturerList } from "actions/manufacturer";
import { getProductCategoryList } from "actions/productCategories";
import { getProductList } from "actions/product";

export default function CommonEquipmentForm({
  formData,
  handleSelectChange,
  handleInputChange,
  handleEquipmentBlur,
}) {
  const dispatch = useDispatch();
  const [manufacturarID, setmanufacturarID] = useState();

  useEffect(() => {
    const filterJSON = [
      {
        field: "Status",
        condition: "eq",
        filterValues: ["ACTIVE"],
      },
    ];
    getManufacturerList(dispatch, { filters: JSON.stringify(filterJSON) });
  }, [dispatch]);

  const manufacturersList = useSelector(
    (state) => state.manufacturer?.manufacturerList?.data?.manufacturer || [],
  );

  const productCategoriesRaw = useSelector(
    (state) =>
      state.productCategory?.productCategoryList?.data?.productCategory || [],
  );

  const productListRaw = useSelector(
    (state) => state.products?.productList?.data?.product || [],
  );

  const categoryOptions = useMemo(() => {
    const selectedManufacturerId = formData.manufacturer?.value?.ID;
    if (!selectedManufacturerId) return [];

    return productCategoriesRaw.filter(
      (c) => c.manufacturerResponse?.ID === selectedManufacturerId,
    );
  }, [formData.manufacturer?.value?.ID, productCategoriesRaw]);

  const filteredProductOptions = useMemo(() => {
    const manufacturerId = formData.manufacturer?.value?.ID;
    const categoryId = formData.category?.value?.ID;

    if (!manufacturerId || !categoryId) return [];

    return productListRaw.filter(
      (p) =>
        p.manufacturer?.ID === manufacturerId &&
        p.productCategory?.ID === categoryId,
    );
  }, [
    formData.manufacturer?.value?.ID,
    formData.category?.value?.ID,
    productListRaw,
  ]);

  const modelOptions = useMemo(() => {
    if (!formData.product?.value) return [];

    return [formData.product.value];
  }, [formData.product?.value]);

  const fetchCategory = (value) => {
    const filterJSON = [
      {
        field: "Status",
        condition: "eq",
        filterValues: ["ACTIVE"],
      },
      {
        field: "ManufacturerID",
        condition: "eq",
        filterValues: [String(value)],
      },
    ];
    getProductCategoryList(dispatch, { filters: JSON.stringify(filterJSON) });
    //
  };

  const fetchProduct = (manufacturarID, categoryID) => {
    const filterJSON = [
      {
        field: "Status",
        condition: "eq",
        filterValues: ["ACTIVE"],
      },
      {
        field: "ManufacturerID",
        condition: "eq",
        filterValues: [String(manufacturarID)],
      },
      {
        field: "ProductCategoryID",
        condition: "eq",
        filterValues: [String(categoryID)],
      },
    ];
    getProductList(dispatch, { filters: JSON.stringify(filterJSON) });
  };

  const handleChange = (key, value) => {
    try {
      handleSelectChange(key, value);
      if (key === "manufacturer") {
        fetchCategory(value?.ID);
        setmanufacturarID(value?.ID);
      }

      if (key == "category") {
        fetchProduct(manufacturarID, value?.ID);
      }
    } catch (error) { }
  };

  return (
    <>
      <CardBody>
        <Row>
          {/* Manufacturer */}
          <Col md="6" className="mb-3">
            <FormGroup
              className={`has-label d-flex flex-column align-items-start ${formData.manufacturer.error ? "has-danger" : ""
                }`}
            >
              <Label>
                Manufacturer <span className="validation-error">*</span>
              </Label>

              <Select
                className={`text-left ${formData.manufacturer.error ? "is-invalid" : ""
                  }`}
                placeholder="Select manufacturer"
                options={manufacturersList}
                getOptionLabel={(option) => option.name}
                getOptionValue={(option) => option.ID}
                classNamePrefix="react-select"
                styles={customStyle}
                value={formData.manufacturer.value}
                onBlur={() => handleEquipmentBlur("manufacturer")}
                onChange={(option) => {
                  // handleSelectChange("manufacturer", option);
                  handleChange("manufacturer", option);
                }}
              />

              {formData.manufacturer.error && (
                <small className="validation-error">
                  {formData.manufacturer.error}
                </small>
              )}
            </FormGroup>
          </Col>

          {/* Category */}
          <Col md="6" className="mb-3">
            <FormGroup
              className={`has-label d-flex flex-column align-items-start ${formData.category.error ? "has-danger" : ""
                }`}
            >
              <Label>
                Category <span className="validation-error">*</span>
              </Label>

              <Select
                className={`text-left ${formData.category.error ? "is-invalid" : ""
                  }`}
                placeholder="Select category"
                options={categoryOptions}
                getOptionLabel={(option) => option.category}
                getOptionValue={(option) => option.ID}
                classNamePrefix="react-select"
                styles={customStyle}
                value={formData.category.value}
                onBlur={() => handleEquipmentBlur("category")}
                onChange={(option) => {
                  // handleSelectChange("category", option);
                  handleChange("category", option);
                }}
                isDisabled={!formData.manufacturer.value}
              />

              {formData.category.error && (
                <small className="validation-error">{formData.category.error}</small>
              )}
            </FormGroup>
          </Col>

          {/* Product */}
          <Col md="6" className="mb-3">
            <FormGroup
              className={`has-label d-flex flex-column align-items-start ${formData.product.error ? "has-danger" : ""
                }`}
            >
              <Label>
                Product <span className="validation-error">*</span>
              </Label>

              <Select
                className={`text-left ${formData.product.error ? "is-invalid" : ""
                  }`}
                placeholder="Select product"
                options={filteredProductOptions}
                getOptionLabel={(option) => option.name}
                getOptionValue={(option) => option.ID}
                classNamePrefix="react-select"
                styles={customStyle}
                value={formData.product.value}
                onBlur={() => handleEquipmentBlur("product")}
                onChange={(option) => {
                  handleSelectChange("product", option);
                }}
                isDisabled={!formData.category.value}
              />

              {formData.product.error && (
                <small className="validation-error">{formData.product.error}</small>
              )}
            </FormGroup>
          </Col>

          {/* Model */}
          <Col md="6" className="mb-3">
            <FormGroup
              className={`has-label d-flex flex-column align-items-start ${formData.model.error ? "has-danger" : ""
                }`}
            >
              <Label>
                Model <span className="validation-error">*</span>
              </Label>

              <Select
                className={`text-left ${formData.model.error ? "is-invalid" : ""
                  }`}
                placeholder="Select model"
                options={modelOptions}
                getOptionLabel={(option) => option.modelNo}
                getOptionValue={(option) => option.modelNo}
                classNamePrefix="react-select"
                styles={customStyle}
                value={formData.model.value}
                onBlur={() => handleEquipmentBlur("model")}
                onChange={(option) => handleSelectChange("model", option)}
                isDisabled={!formData.product.value}
              />

              {formData.model.error && (
                <small className="validation-error">{formData.model.error}</small>
              )}
            </FormGroup>
          </Col>

          {/* Serial No */}
          <Col md="6" className="mb-3">
            <FormGroup
              className={`has-label d-flex flex-column align-items-start ${formData.serialNo.error ? "has-danger" : ""
                }`}
            >
              <Label>
                Serial No. <span className="validation-error">*</span>
              </Label>
              <Input
                name="serialNo"
                placeholder="Enter serial no"
                type="text"
                value={formData.serialNo.value}
                onChange={handleInputChange}
                onBlur={() => handleEquipmentBlur("serialNo")}
                maxLength={100}
              />
              {formData.serialNo.error && (
                <small className="validation-error">{formData.serialNo.error}</small>
              )}
            </FormGroup>
          </Col>

          {/* Seller */}
          <Col md="6" className="mb-3">
            <FormGroup
              className={`has-label d-flex flex-column align-items-start ${formData.seller.error ? "has-danger" : ""
                }`}
            >
              <Label>
                Seller <span className="validation-error">*</span>
              </Label>

              <Select
                className={`text-left ${formData.seller.error ? "is-invalid" : ""
                  }`}
                placeholder="Select seller"
                options={sellerOptions}
                classNamePrefix="react-select"
                styles={customStyle}
                value={formData.seller.value}
                onBlur={() => handleEquipmentBlur("seller")}
                onChange={(option) => handleSelectChange("seller", option)}
              />

              {formData.seller.error && (
                <small className="validation-error">{formData.seller.error}</small>
              )}
            </FormGroup>
          </Col>

          {/* Asset Tag */}
          <Col md="6" className="mb-3">
            <FormGroup className="d-flex flex-column align-items-start">
              <Label>Asset Tag</Label>
              <Input
                name="assetTag"
                placeholder="Enter asset tag"
                type="text"
                value={formData.assetTag.value}
                onChange={handleInputChange}
                maxLength={100}
              />
            </FormGroup>
          </Col>

          {/* Purchase Date */}
          <Col md="6" className="mb-3">
            <FormGroup className="has-label d-flex flex-column align-items-start">
              <Label>Purchase Date</Label>
              <Input
                type="date"
                name="purchaseDate"
                value={formData.purchaseDate.value}
                onChange={handleInputChange}
                onBlur={() => handleEquipmentBlur("purchaseDate")}
              />
            </FormGroup>
          </Col>
        </Row>

        {/* WARRANTY SECTION */}
        <Row>
          <Col md="6" className="mb-0 d-flex align-items-center mb-sm-2">
            <FormGroup>
              <Label for="warrantyCheckbox">Warranty</Label>
              <Input
                type="checkbox"
                id="warrantyCheckbox"
                name="warranty"
                checked={formData.warranty.value}
                onChange={handleInputChange}
                className="custom-checkbox"
              />
            </FormGroup>
          </Col>

          {formData.warranty.value && (
            <>
              <Col md="6" className="mb-0">
                <FormGroup>
                  <Label for="standardWarranty">
                    Standard Warranty (2 Years)
                  </Label>
                  <Input
                    type="checkbox"
                    id="standardWarranty"
                    name="standardWarranty"
                    checked={formData.standardWarranty.value}
                    onChange={handleInputChange}
                    className="custom-checkbox"
                  />
                </FormGroup>
              </Col>

              <Col md="6" className="mb-0 mt-2">
                <FormGroup
                  className={`has-label d-flex flex-column align-items-start ${formData.warrantyStartDate.error ? "has-danger" : ""
                    }`}
                >
                  <Label>Warranty Start Date
                    {formData.warranty.value && <span className="validation-error">*</span>}
                  </Label>
                  <Input
                    id="warrantyStartDate"
                    name="warrantyStartDate"
                    type="date"
                    placeholder="Warranty start date"
                    value={formData.warrantyStartDate.value}
                    onChange={handleInputChange}
                    onBlur={() => handleEquipmentBlur("warrantyStartDate")}
                  />
                  {formData.warrantyStartDate.error && (
                    <small className="validation-error">
                      {formData.warrantyStartDate.error}
                    </small>
                  )}
                </FormGroup>
              </Col>

              {!formData.standardWarranty.value && (
                <Col md="6" className="mb-0 mt-2 mb-sm-3">
                  <FormGroup
                    className={`has-label d-flex flex-column align-items-start ${formData.warrantyEndDate.error ? "has-danger" : ""
                      }`}
                  >
                    <Label>Warranty End Date
                      {formData.warranty.value && !formData.standardWarranty.value && <span className="validation-error">*</span>}
                    </Label>
                    <Input
                      id="warrantyEndDate"
                      name="warrantyEndDate"
                      type="date"
                      value={formData.warrantyEndDate.value}
                      onChange={handleInputChange}
                      onBlur={() => handleEquipmentBlur("warrantyEndDate")}
                      placeholder="Warranty end date"
                      min={formData.warrantyStartDate.value || ""}
                      disabled={!formData.warrantyStartDate.value}
                    />
                    {formData.warrantyEndDate.error && (
                      <small className="validation-error">
                        {formData.warrantyEndDate.error}
                      </small>
                    )}
                  </FormGroup>
                </Col>
              )}
            </>
          )}
        </Row>
      </CardBody>
    </>
  );
}
